import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const whatsappUrl = `https://wa.me/14377570478?text=${encodeURIComponent(
    'Hi VK Tax Guide! I would like to know more about your tax filing services.'
  )}`;

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/services', label: 'Services' },
    { path: '/cpa-services', label: 'CPA Services' },
    { path: '/tax-resources', label: 'Tax Resources' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-slate-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-3">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center space-x-3">
            <img
              src="https://customer-assets.emergentagent.com/job_accounting-sms-hub/artifacts/7650y7gp_WhatsApp%20Image%202026-01-28%20at%2011.28.02.jpeg"
              alt="VK Tax Guide Logo"
              className="h-20 w-auto object-contain"
            />
          </Link>

          <div className="hidden md:flex items-center space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative px-4 py-2 rounded-lg font-medium transition-all ${
                  isActive(link.path)
                    ? 'text-[#005782] bg-[#E0F2FE]'
                    : link.highlight
                    ? 'text-[#005782] hover:bg-[#E0F2FE]'
                    : 'text-slate-700 hover:text-[#005782] hover:bg-slate-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:block">
            <Button
              asChild
              data-testid="nav-whatsapp-btn"
              className="bg-[#25D366] text-white hover:bg-[#20BA5A] rounded-lg px-6 py-2 font-medium transition-all shadow-lg hover:shadow-xl active:scale-95"
            >
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer">
                WhatsApp
              </a>
            </Button>
          </div>

          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden p-2 rounded-lg hover:bg-slate-100"
            data-testid="mobile-menu-btn"
          >
            {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isOpen && (
          <div className="md:hidden mt-4 pb-4 space-y-2">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block px-4 py-2 rounded-lg font-medium transition-all ${
                  isActive(link.path)
                    ? 'text-[#005782] bg-[#E0F2FE]'
                    : 'text-slate-700 hover:text-[#005782] hover:bg-slate-50'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <Button className="w-full bg-[#25D366] text-white hover:bg-[#20BA5A] rounded-lg px-6 py-2 font-medium mt-4" asChild>
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)}>
                WhatsApp
              </a>
            </Button>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;